import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { WalletControl } from '@pipes/walletControl.pipe';

@Component({
  selector: 'pay3000-wettarena-component',
  templateUrl: './pay3000-wettarena.component.html',
})
export class Pay3000WettarenaComponent implements OnInit {
  //bet3000
  isInitial = true;
  isInitialSuccess = false;
  isConfirmed = false;
  // @Input() isOpen;
  pay3000Form: UntypedFormGroup;
  errorMessage: boolean;
  errorMessage2: boolean;
  pay3000Customer: any;
  pay3000CustomerSuccess: any;
  isRevokeConfirm: boolean;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public _MatDialog: MatDialog
  ) {
    this.pay3000Form = _FormBuilder.group({
      pay3000Id: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),

      terms_and_condition: new UntypedFormControl({ value: false, disabled: false }, [Validators.requiredTrue]),
    });
    this.isInitial = true;
  }

  ngOnInit() {
    this.getWalletList();
  }
  getWalletList() {
    this._ApiService.getWalletList().then(result => {
      result.forEach(element => {
        if (element.BranchType == 2) {
          this.isConfirmed = true;
          this.isInitialSuccess = false;
          this.isInitial = false;
          this.pay3000Customer = element;
        }
      });
    });
  }
  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Withdraw', true);
  }

  registerButton() {
    this._ApiService.savePay3000(this.pay3000Form).then(result => {
      if (result.Status == false) {
        this.errorMessage = true;
        this.isInitial = true;
        // this.step.initialSuccess=false
      } else {
        this.isInitial = false;
        this.errorMessage = false;
        this.isInitialSuccess = true;
      }
      this.pay3000Customer = result;
    });
  }

  isRevokeConfirmation() {
    this.isRevokeConfirm = !this.isRevokeConfirm;
  }
  confirmButton() {
    const walletControl = new WalletControl(this._UserHelper);

    return this._ApiService.confirmPay3000(this.pay3000Customer.Data.consentId).then(result => {
      if (result.Status == false) {
        this.isConfirmed = false;
        this.errorMessage2 = true;
        // this.isInitial = true;
        // this.step.initialSuccess=false
      } else {
        this._ApiService.getSelfLimits().then(x => {
          if (x && x.length > 0) {
            const hasDepositMontlyLimitConsumed = x[0].DepositMonthlyLimitConsumed;

            this._ApiService.getWalletList().then(result => {
              const pay3000WalletInfo = result.find(element => element.BranchType == 2);

              if (pay3000WalletInfo && walletControl.transform(true, 'IsVerification')) {
                this.isConfirmed = true;
                this.isInitialSuccess = false;
                this.isInitial = false;
                this.pay3000Customer = pay3000WalletInfo;
                this._ApiService.switchWallet(pay3000WalletInfo.CustomerId, pay3000WalletInfo.BranchId).then();
              }
            });
          }
        });
      }
    });
  }

  revokePay3000() {
    this._ApiService.revokePay3000(this.pay3000Customer.ConsentId).then(result => {
      if (result.Status == false) {
        this.isInitial = false;
        this.isInitialSuccess = false;
        this.isConfirmed = true;
      } else {
        this.isInitial = true;
        // this.errorMessage = false;
        this.isInitialSuccess = false;
        this.isConfirmed = false;
      }
    });
  }
  goAccountOverView() {
    //Money Transactions sayfasına yönlendirmek için yazıldı
    this._UiHelper.b3000SetAcountMobileState('open', 3);
  }

  OpenDocumentUploadPage(selectMenu?) {
    selectMenu = 8;
    // this.selectMenu=selectMenu;
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }
}
